import { Component, h, Prop } from '@stencil/core';

/**
 * Component to represent H1 of a page.
 */

@Component({
  tag: 'fccd-header',
  styleUrl: 'fccd-header.scss',
})
export class Header {
  /**
   * Unique identifier for the h1.
   */
  @Prop() elementId: string = 'page-header';

  /**
   * The heading text.
   */

  @Prop() headingText: string;

  /**
   * The blurb text, it is optional since not all pages will have blurb text beneath the header.
   */

  @Prop() blurbText?: string;

  render() {
    return (
      <hp5-container type="ten-one">
        <div class="heading-section">
          <hp5-heading size-selection="xxl" tag-selection="h1" element-id={this.elementId}>
            {this.headingText}
          </hp5-heading>
          {this.blurbText ? (
            <div>
              <hp5-spacing-vertical xs="sm" />
              <hp5-semantic size-selection="md">
                <section class="md">{this.blurbText}</section>
              </hp5-semantic>
            </div>
          ) : null}
        </div>
      </hp5-container>
    );
  }
}
